import React from "react";
import {Box, Tooltip} from "@mui/material";
import {convertLocalDateToDate, formatFullDMY,} from "crqlar-react-common/dist/utils/date.util";
import {CakeIcon} from "./base/CakeIcon";

export function BirthdayElement({
                                    birthday,
                                    selectedDate,
                                    name,
                                }: {
    birthday: string | Date | undefined;
    selectedDate: Date;
    name?: string;
}) {
    if (!birthday) {
        return null;
    }

    const birthdayDate = birthday instanceof Date ? birthday : convertLocalDateToDate(birthday);
    if (!birthdayDate) {
        return null;
    }

    const isBirthday = birthdayDate.getMonth() === selectedDate.getMonth()
        && birthdayDate.getDate() === selectedDate.getDate();

    const formattedDate = formatFullDMY(birthdayDate);
    if (!isBirthday) {
        return (
            <Box component="span" sx={{fontVariantNumeric: "tabular-nums"}}>
                {formattedDate}
            </Box>
        );
    }

    const tooltipTitle = name
        ? `${formattedDate} is ${name}'s birthday`
        : `${formattedDate} is the guest's birthday`;

    return (
        <Tooltip title={tooltipTitle} arrow>
            <Box
                sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.5,
                    fontVariantNumeric: "tabular-nums",
                }}
            >
                <Box component="span">{formattedDate}</Box>
                <Box
                    component="span"
                    aria-hidden="true"
                    sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        color: "error.main",
                    }}
                >
                    <CakeIcon size={16}/>
                </Box>
            </Box>
        </Tooltip>
    );
}
